import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'div'> & {
  collapsed?: boolean
}

export const AppLogo: FC<Props> = ({ className, collapsed, ...props }) => {
  return (
    <div {...props} className={clsx(['inline-flex text-black', className])}>
      <img src="/images/logo_black.svg" className="min-w-[32px]" />
      <span
        className={clsx([
          'overflow-hidden whitespace-nowrap text-2xl font-bold leading-none transition-all ease-in-out',
          collapsed ? 'w-0 opacity-0' : 'ml-2 opacity-100'
        ])}
      ></span>
    </div>
  )
}
